import { Tabs, TabsContent, TabsList, TabsTriggerAcc } from '@/components/common/Tabs';
import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import ForeverCouponList from './forever';
import OneTimeCouponList from './one-time';
import { COUPON_TYPE } from '@/types/enums';

export default observer(function CouponManagementPage() {
    // hook
    const { t } = useTranslation();

    // store
    const {
        // modalStore: { showAlertModal, hideModal },
        couponStore: {
            couponType,
            setObservable
        }
    } = useStore();

    // function

    // const
    const tabsConfig = [
        {
            value: `${COUPON_TYPE.FOREVER_USE}`,
            label: t('words_title.coupon_forever'),
            Component: ForeverCouponList
        },
        {
            value: `${COUPON_TYPE.ONE_TIME_USE}`,
            label: t('words_title.coupon_one_time'),
            Component: OneTimeCouponList
        }
        // {
        //     id: 'actions',
        //     accessorKey: 'action',
        //     header: t('field.action'),
        //     size: 400,
        //     enableSorting: false,
        //     cell: ({ row: { original } }) => (
        //         <TableActionButtons
        //             onView={() => handleClickEditCoupon(original.id)}
        //         // onView={() => handleClickViewCoupon(original.id)}
        //         // onEdit={() => handleClickEditCoupon(original.id)}
        //         // onDelete={() => handleClickDeleteCoupon(original.id)}
        //         />
        //     )
        // }
    ];

    // function
    const handleTabChange = (tabValue: string) => {
        setObservable('couponType', tabValue);
    };

    return (
        <div>
            <Tabs
                value={couponType?.toString()}
                onValueChange={handleTabChange}
                className='w-full'
            >
                <TabsList
                    className='grid w-full gap-1.5 grid-cols-4'
                >
                    {tabsConfig.map(({ value, label }) => (
                        <TabsTriggerAcc
                            key={value}
                            value={value}
                        >
                            {label}
                        </TabsTriggerAcc>
                    ))}
                </TabsList>
                {tabsConfig.map(({ value, Component }) => (
                    <TabsContent key={value} value={value} className='mt-0'>
                        <Component />
                    </TabsContent>
                ))}
            </Tabs>
        </div>
    );
});
